var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path3, _path4, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path5, _path6, _rect19, _rect20, _rect21, _rect22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.07788,
    width: 0.454545,
    height: 2.62987,
    rx: 0.227273,
    fill: "#3085EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.55835,
    y: 1.948,
    width: 1.2987,
    height: 2.43507,
    rx: 0.649351,
    fill: "#98A0A0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.80042,
    y: 1.948,
    width: 1.05679,
    height: 2.43507,
    rx: 0.528393,
    fill: "#639BE0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.48706,
    y: 3.70117,
    width: 3.31169,
    height: 2.43507,
    rx: 1.21753,
    fill: "#98A0A0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.10376,
    y: 3.70117,
    width: 2.69481,
    height: 2.43507,
    rx: 1.21753,
    fill: "#308DFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15895 9.65923V13.1172V16.4285H1.59094V9.53348C1.59094 9.21493 1.93651 9.14926 2.1093 9.15625H5.47861C6.12655 9.20655 6.20214 9.51252 6.15895 9.65923Z",
    fill: "#125FBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09496 9.65923V13.1172V16.4285H1.94812V9.53348C1.94812 9.21493 2.26183 9.14926 2.41868 9.15625H5.47735C6.06555 9.20655 6.13417 9.51252 6.09496 9.65923Z",
    fill: "#4A9CFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75964,
    y: 9.9353,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#125FBC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75964,
    y: 9.9353,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#125FBC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75964,
    y: 11.2339,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#125FBC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75964,
    y: 12.5325,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#125FBC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75964,
    y: 13.8311,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#125FBC"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75964,
    y: 15.1296,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#125FBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35051 5.94208V11.2992V16.4291H4.77258V5.74728C4.77258 5.25377 5.1189 5.15204 5.29206 5.16286H8.66869C9.31804 5.24078 9.3938 5.71481 9.35051 5.94208Z",
    fill: "#85BCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27672 5.94203V11.2988V16.4283H5.12988V5.74724C5.12988 5.25376 5.44359 5.15204 5.60045 5.16286H8.65911C9.24731 5.24078 9.31594 5.71477 9.27672 5.94203Z",
    fill: "#3085EE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94153,
    y: 5.94141,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#85BCFF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94153,
    y: 5.94141,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#85BCFF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94153,
    y: 13.7336,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#85BCFF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94153,
    y: 15.0325,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#85BCFF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94153,
    y: 7.24023,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#85BCFF"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94153,
    y: 8.53906,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#85BCFF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94153,
    y: 9.83765,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#85BCFF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94153,
    y: 11.1362,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#85BCFF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 5.94153,
    y: 12.4353,
    width: 2.53247,
    height: 0.38961,
    rx: 0.194805,
    fill: "#85BCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07788 11.8844V16.4298H13.8961V11.8844C13.948 11.4168 13.5065 11.2783 13.2792 11.2675H7.8571C7.2597 11.2415 7.0887 11.6679 7.07788 11.8844Z",
    fill: "#508BD2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53247 11.8842V16.4287H13.8922V11.8842C13.9406 11.4168 13.5288 11.2783 13.3168 11.2675H8.25929C7.70206 11.2415 7.54257 11.6678 7.53247 11.8842Z",
    fill: "#FE7979"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 8.66895,
    y: 12.8899,
    width: 3.83117,
    height: 0.422078,
    rx: 0.211039,
    fill: "#C84040"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 8.66895,
    y: 13.9612,
    width: 3.83117,
    height: 0.422078,
    rx: 0.211039,
    fill: "#C84040"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 8.66895,
    y: 15.1296,
    width: 3.83117,
    height: 0.422078,
    rx: 0.211039,
    fill: "#C84040"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    y: 16.4285,
    width: 15,
    height: 0.324675,
    rx: 0.162338,
    fill: "#1F77E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.60786b19f840b93298c627caf4f8e48c.svg";
export { ForwardRef as ReactComponent };